import { render, staticRenderFns } from "./UserViewSidebar.vue?vue&type=template&id=24bfd472&scoped=true&"
import script from "./UserViewSidebar.vue?vue&type=script&lang=js&"
export * from "./UserViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UserViewSidebar.vue?vue&type=style&index=0&id=24bfd472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bfd472",
  null
  
)

export default component.exports